import { render } from "./GanttList.vue?vue&type=template&id=28560c8d"
import script from "./GanttList.vue?vue&type=script&lang=ts"
export * from "./GanttList.vue?vue&type=script&lang=ts"
script.render = render

export default script